






















import axios from "axios";

import Vue from "vue";
import WeatherCard from "./components/WeatherCard.vue";

export default Vue.extend({
  name: "App",
  data: () => ({
    city: null,
    loading: false,
    timerId: 0,
    cityName: ""
  }),
  components: {
    WeatherCard
  },
  created() {
    const city = localStorage.getItem("city");
    if (city) {
      this.cityName = city;
      this.getCity();
    }
  },
  methods: {
    getCity() {
      this.loading = true;
      axios
        .get(
          process.env.VUE_APP_WEATHER_API +
            this.cityName +
            "&appid=" +
            process.env.VUE_APP_WEATHER_API_KEY
        )
        .then(response => {
          this.loading = false;
          if (response.data.cod === 429) {
            this.$toasted.info(
              "API requests for this subscription have been exceeded"
            );
          } else {
            localStorage.setItem("city", this.cityName);
            this.city = response.data;
          }
        })
        .catch(error => {
          this.loading = false;
          this.$toasted.error("City not found");
        });
    }
  }
});
